module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('groupPages.modules.contact.intro', {
    groupName: _vm.group.name
  })))]), (_vm.isConnected) ? _c('form', {
    attrs: {
      "role": "form",
      "method": "post",
      "onsubmit": "return false"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.errors.has('title')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('groupPages.modules.contact.titlePlaceholder'),
      "disabled": _vm.status != null,
      "name": "title"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.errors.has('message')
    },
    attrs: {
      "rows": "5",
      "placeholder": _vm.$t('groupPages.modules.contact.messagePlaceholder'),
      "disabled": _vm.status != null,
      "name": "message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.status != null
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v("  " + _vm._s(_vm.$t('globals.send')))]), _c('p', [(_vm.status == _vm.STATUS.SENDING) ? [_vm._v(_vm._s(_vm.$t('globals.sending')))] : _vm._e()], 2), _c('div', {
    staticClass: "cf"
  })]) : _c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.connect
    }
  }, [_vm._v(_vm._s(_vm.$t('groupPages.modules.contact.pleaseSignin')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9100c6e2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupPages/GroupPageContact.vue
// module id = 1279
// module chunks = 2